import SvgIcon from '@/components/atoms/SvgIcon';
import iconsPng from '@/assets/img/png/icons';
import svgIcons from '@/assets/svg/icons';
import { Box, HStack, Image, Text, Tooltip, VStack } from '@chakra-ui/react';
import { THealthDomain } from '@/types/Health.types';
import { READINESS_DOMAIN_LONG_DESCRIPTION, WELLNESS_DOMAINS_LONG_DESCRIPTIONS } from '@/constants/stringVars';
import { background } from '@/theme/colors/palettes';
import { READINESS_DOMAIN } from '@/constants';

export type ContentFocusValue = THealthDomain | typeof READINESS_DOMAIN;

type ContentFocusTileProps = {
  label: string;
  value: ContentFocusValue;
  isSelected: boolean;
  onToggle: (value: ContentFocusValue) => void;
};

const ContentFocusTile = ({ label, value, isSelected, onToggle }: ContentFocusTileProps) => (
  <HStack
    as={'button'}
    type={'button'}
    onClick={() => onToggle(value)}
    width={'100%'}
    minHeight={'48px'}
    padding={'10px 14px'}
    borderRadius={'8px'}
    backgroundColor={isSelected ? background.lightPurple : 'white'}
    borderWidth={'3px'}
    borderColor={isSelected ? 'primary.500' : 'transparent'}
    boxShadow={isSelected ? '0px 2px 12px 0px #1A00B940' : '0px 2px 4px 0px #0041790D'}
    justifyContent={'space-between'}
  >
    <HStack spacing={'12px'}>
      <Box
        width={'28px'}
        height={'28px'}
        borderRadius={'50%'}
        backgroundColor={'primary.100'}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Image src={iconsPng.wellnessDomainsPurple[value]} alt="" width={'16px'} height={'16px'} />
      </Box>
      <Text color={'text.darkBlue'} fontSize={'14px'} lineHeight={'18px'} fontWeight={'800'}>
        {label}
      </Text>
    </HStack>

    <Tooltip
      label={
        value === READINESS_DOMAIN
          ? READINESS_DOMAIN_LONG_DESCRIPTION
          : WELLNESS_DOMAINS_LONG_DESCRIPTIONS[value as THealthDomain]
      }
      padding={'14px'}
      borderRadius={'6px'}
      color={'text.darkBlue'}
      backgroundColor={'extra.white'}
      boxShadow={'0px 2px 8px 0px #00417933'}
      placement="right"
      top={24}
      right={5}
    >
      <VStack>
        <SvgIcon
          iconPath={svgIcons.infoCircle}
          color={background.separatorBlue}
          size={20}
          boxHeight={20}
          boxWidth={20}
        />
      </VStack>
    </Tooltip>
  </HStack>
);

export default ContentFocusTile;
